import {
	SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_LIGHT,
	SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT,
	SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DEFAULT_LIGHT,
	SYS_SPACE_RELATIVE_BP_MD_MD,
	SYS_SPACE_RELATIVE_BP_SM_MD,
	SYS_SPACE_RELATIVE_BP_SM_SM,
} from '@oneaudi/unified-web-common';

import styled, { keyframes } from 'styled-components';
import { zIndexTop } from '~/styles/tokens';

export const slideDown = keyframes`
	from {
		height: 0;
	}
	to {
		height: var(--radix-collapsible-content-height);
	}
`;

export const slideUp = keyframes`
	from {
		height: var(--radix-collapsible-content-height);
		opacity: 1;
	}
	to {
		height: 0;
		opacity: 0;
	}
`;

export const SelectionCardStyles = styled.div<{ isDebug?: boolean; hasTechData?: boolean }>`
	position: relative;
	width: 100%;
	display: inline-flex;
	flex-direction: column;
	transition: all 0.1s ease-in-out;

	&::after {
		display: inline-block;
		content: ' ';
		position: absolute;
		top: 0px;
		bottom: -1px;
		left: 0px;
		right: 0px;
		border: 1px solid ${SEM_COLOR_FORMS_SURFACE_CONTROL_STROKE_DEFAULT_LIGHT};
		background: transparent;
		pointer-events: none;
	}

	&.is-selected {
		&::after {
			border: 2px solid ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT};
			z-index: 1;
		}

		&:not(:first-child)::after {
			top: -1px;
		}

		&.is-read-only::after {
			border-color: ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_LIGHT};
		}
	}

	&.is-read-only {
		&::after {
			border-color: ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_LIGHT};
		}
	}

	&:hover:not(.is-read-only)::after {
		border-color: ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT};
		z-index: 2;
	}

	.image-container {
		overflow: hidden;
		width: 100%;

		img {
			width: 100%;
			aspect-ratio: 3 / 1;
			object-fit: cover;
			object-position: 100% 0;
		}
	}

	.top-item {
		grid-area: 1 / 1;
	}

	.loading-item {
		grid-area: 1 / 1;
		height: 20px;
		width: 20px;
		z-index: ${zIndexTop};
	}

	.selection-card-content {
		padding: ${SYS_SPACE_RELATIVE_BP_MD_MD};
	}

	.selection-card-title {
		display: grid;
		grid-template-columns: 1fr;
		place-items: start;
		${({ isDebug }) => {
			if (isDebug) {
				return `
					label div:last-child {
						line-break: anywhere;
					}
				`;
			}
		}}
	}

	.selection-card-header {
		display: flex;
		flex-direction: column;
		place-items: start;
		${({ hasTechData }) => {
			if (hasTechData) {
				return `
					gap: ${SYS_SPACE_RELATIVE_BP_SM_SM};
					padding-block-end: ${SYS_SPACE_RELATIVE_BP_SM_SM};
				`;
			}
		}}
	}

	.selection-card-description {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_RELATIVE_BP_MD_MD};
		align-items: start;
		margin-bottom: 2px;
	}

	.collapsible-content {
		overflow: hidden;

		.content-container {
			display: grid;
			gap: 1rem;
			padding: 0 0 ${SYS_SPACE_RELATIVE_BP_SM_MD} 0;
		}

		.disclaimer-wrapper {
			margin-top: ${SYS_SPACE_RELATIVE_BP_SM_MD};
		}
	}

	.collapsible-content[data-state='open'] {
		animation: ${slideDown} 400ms ease;
	}

	.collapsible-content[data-state='closed'] {
		animation: ${slideUp} 400ms ease;
	}
`;
